import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/Button';
import { BiSolidQuoteAltLeft } from 'react-icons/bi';
import { LuMoveRight } from 'react-icons/lu';
import elie from '../../../assets/elie.png';
import ghad from '../../../assets/ghad.png';
import emmanuel from '../../../assets/emmanuel.png';
import providence from '../../../assets/providence.png';
import valentine from '../../../assets/valentine.png';
import niyigaba from '../../../assets/niyigaba.png';
import niyomugabo from '../../../assets/niyomugabo.png';
import manirumva_samuel from '../../../assets/manirumva_samuel.jpeg';
import manirumva_robot from '../../../assets/manirumva_robot.jpeg';
import gisubizo_dinah from '../../../assets/gisubizo_dinah.jpeg';
import tumwitegure_joyeuse from '../../../assets/tumwitegure_joyeuse.jpeg';
import gashora_girls_academy from '../../../assets/gashora_girls_academy_2024-2025 .jpg';
import Partners from '../../partners/Partners';
import Footer from '../../../components/Footer';

const stories = [
  {
    id: 1,
    name: 'Manirumva Samuel',
    role: 'ASEF student',
    location: 'RWANDA',
    image: manirumva_samuel,
    date: 'Oct 17, 2025',
    paragraphs: [
      {
        text: (
          <>
            <i>
              “We must keep asking ourselves how we are using education to
              transform lives and in how much time. An education that does not
              transform your life or the life of others is a wasted education.”
            </i>
            <br />— President Paul Kagame, speaking to 10,000 University of
            Rwanda students in 2015.
          </>
        ),
      },

      {
        text: 'These words deeply resonate with Manirumva Samuel, an ASEF student from Nyabihu District, currently studying Electronics and Telecommunication at Groupe Scolaire Indangaburezi; Ruhango. Although he was not yet in high school when this message was delivered, it planted a seed of purpose in him, one that continues to grow through innovation and creativity',
      },
      {
        text: 'Recently, Samuel built a functional robot designed to assist in reception and registration tasks. The robot can classify people based on predefined algorithms and commands, efficiently sorting them according to the required categories.',
      },

      {
        text: 'When ASEF introduced a new structure for student meetings; grouping students by their academic performance into STARS (top 5), ADVANCING (6th position to top half of the class), and GROWTH ZONE (lower half of the class), Samuel saw an opportunity. He programmed his robot to help students easily identify their group: after entering their name and class position, the robot automatically displays their category.',
      },

      {
        text: (
          <>
            <i>
              “This robot can also be used in other places such as hotels,
              restaurants, libraries, or anywhere people need to be
              pre-registered,”
            </i>{' '}
            Samuel explained.
          </>
        ),
      },
      {
        text: (
          <>
            {' '}
            Samuel’s innovation reflects not only his creativity but also his
            determination to apply knowledge for real-life impact. His message
            to fellow ASEF students is inspiring and direct:
            <i>
              “As ASEF students, we should put into action what we study every
              day and use our skills to solve community problems.”
            </i>{' '}
          </>
        ),
      },
      {
        image: manirumva_robot,
        image_description: 'Functinal robot created by Samuel',
      },
      {
        youtube:
          'https://www.youtube.com/embed/CToSlPWAxbI?si=ijgAYuq64MPH3t5U',
      },
    ],
  },
  {
    id: 2,
    name: 'Gisubizo Dinah',
    role: 'ASEF student',
    location: 'RWANDA',
    image: gisubizo_dinah,
    date: 'Oct 17, 2025',
    paragraphs: [
      {
        text: 'From June 2nd to 5th, 2025, Rwanda hosted the National Skills Competition 2025, an event that brought together 93 top-performing students from Technical Secondary Schools (TSS) and Rwanda Polytechnic colleges across the country. The competition showcased outstanding talent and innovation in various disciplines, highlighting the growing importance of technical and vocational education in driving Rwanda’s development.',
      },

      {
        text: 'Among the participants was Dinah, an ASEF-supported student from Nyabihu District, who studies Food and Beverage Operations at CBS Kinigi. Competing against the best students from across the nation, Dinah demonstrated remarkable professionalism, creativity, and practical skill throughout the competition.',
      },
      {
        text: 'Her hard work and dedication paid off; Dinah won the gold medal in the Food and Beverage Operations category. In addition to national recognition, she received a cash prize of 500,000 Rwandan francs, awarded to the overall winner in her trade.',
      },

      {
        text: 'Dinah’s victory is a proud moment not only for her but also for the African Students Education Fund (ASEF), which continues to empower young Rwandans with education, mentorship, and opportunities to realize their full potential. Her success stands as an inspiring example of what is possible when talent meets opportunity and support.',
      },

      {
        text: 'As Rwanda continues to invest in technical education, achievements like Dinah’s remind us of the transformative power of skill, discipline, and resilience in shaping a brighter future for both individuals and the nation.',
      },
      {
        youtube:
          'https://www.youtube.com/embed/CToSlPWAxbI?si=ijgAYuq64MPH3t5U',
      },
    ],
  },

  {
    id: 3,
    name: 'Tumwitegure Joyeuse',
    role: 'ASEF student',
    location: 'RWANDA',
    image: tumwitegure_joyeuse,
    date: 'Oct 17, 2025',
    paragraphs: [
      {
        text: 'Gashora Girls Academy of Science and Technology (GGAST) is one of Rwanda’s most prestigious high schools, located in Bugesera District. Known for its academic excellence and strong focus on science, technology, leadership, and innovation, the school has nurtured some of the brightest young women in the country.',
      },

      {
        text: 'Over the years, ASEF has proudly supported some students who went at Gashora and have gone on to attend top international universities after graduation. Among the six ASEF students currently studying there in the 2025–2026 academic year is Tumwitegure Joyeuse, a bright and ambitious young woman from the ASEF program.',
      },
      {
        text: (
          <>
            Joyeuse expressed deep appreciation for ASEF’s support since joining
            in 2020, saying:{' '}
            <i>
              “My journey in ASEF has been full of memories, excitement, and
              learning from others. It has not only been about paying my school
              fees, but also about the exciting life experiences that I think I
              will truly miss.”
            </i>{' '}
          </>
        ),
      },

      {
        text: 'For many Rwandan girls, joining Gashora is a dream , but not all get the chance to make it a reality. Joyeuse shared that she first heard about the school during one of ASEF’s advisory meetings, though she didn’t fully understand what it was or feel confident enough to apply. However, because she was one of the best-performing students at the time, her name was recommended to Gashora, and she was later selected to join.',
      },

      {
        text: 'When asked about the criteria for admission, Joyeuse explained that students must be academically strong , maintaining clean report cards and strong national exam results,  and then complete the application form once it is available.',
      },
      {
        text: (
          <>
            <i>
              “You don’t have to be good at English. Gashora doesn’t focus on
              that during selection because it knows it will train you and help
              you become the best version of yourself,”
            </i>{' '}
            she added.
          </>
        ),
      },

      {
        text: 'In addition to academic performance, the quality of the application form and a student’s leadership potential are also key factors in the selection process.',
      },

      {
        text: 'According to Gashora website, Gashora is the right fit for any girl who:\nWants to be challenged by great teachers who expect the best from her.\nWants to improve her English speaking, writing, and reading.\nWishes to study sciences in any stream.\nDesires to grow as a leader and explore new skills, talents, and interests.\nAspires to discover her leadership potential and positively impact her community.\nEnjoys learning alongside girls from diverse backgrounds.\nWants to have fun — while working hard too!',
      },
      {
        text: (
          <>
            To current ASEF students who dream of joining Gashora, Joyeuse
            shares this encouragement:{' '}
            <i>
              “Don’t let your thoughts discourage you that it’s too hard. Focus
              on your performance, and when the time for applications comes, as
              you prepare to join Senior Four, don’t hesitate to apply.”
            </i>
          </>
        ),
      },

      {
        image: gashora_girls_academy,
        image_description:
          'ASEF students at Gashora Girls Academy of Science and Technology in 2024-2025 Academic year',
      },
      {
        youtube:
          'https://www.youtube.com/embed/CToSlPWAxbI?si=ijgAYuq64MPH3t5U',
      },
    ],
  },
  {
    id: 4,
    name: 'Iradukunda Providence',
    role: 'Executive Director at Youth Estimation for Peace and Development',
    location: 'RWANDA',
    image: providence,
    paragraphs: [
      {
        text: 'I am Iradukunda Providence, a Rwandan female from Burera District, Cyanika Sector. I am the third of eleven children, raised by both my mother and father. I come from a financially humble family in the rural area of Cyanika. I attended GS Butete for primary school, where I excelled in the national examination and was sent to Gicumbi to study at Ecole Secondaire Sancta Maria Karambo. I spent three years there and performed well in the Ordinary Level examination, scoring 13 aggregates under the 2016 ranking system.',
      },
      {
        text: 'Afterward, the government assigned me to RP Kigali College to complete my high school studies, where I studied Electronics and Telecommunication. It had always been a big dream of mine to study in Kigali, so this was a major step toward achieving that dream.',
      },
      {
        text: "The challenge came later when I could no longer afford to attend school. My family was unable to sponsor my studies, and it seemed like I wouldn't make it. That\u2019s when I reached out to the Social Affairs Officer in our sector, who knew me and was aware of my good academic performance. She introduced me to ASEF. When ASEF stepped in, everything changed. I received school fees and all the supplies I needed: notebooks, pens, a mattress, hygiene materials, and more. I am truly thankful to ASEF, because without it, continuing my studies would not have been possible.",
      },
      {
        text: 'Studying at RP Kigali College was a bit challenging. I had to live outside the school since there were no dormitories available. At the time, I was only 15 years old, and because of my small size, I looked 12. Some students joked that I wouldn’t survive in the ghetto the area outside campus. To cut the long story short, I managed to live with 3 schoolmates for one year and one semester before moving into the school\u2019s dormitories.',
      },

      {
        text: 'In 2018, when I was in Senior Five, I had the idea of creating a group or club focused on developing student talents. At the time, I was a singer and a poet. I had already participated in several competitions and won various awards, including one organized by Never Again Rwanda.',
      },

      {
        text: 'During the first term holiday, I visited the Executive Secretary of Cyanika Sector and introduced my idea to form a club that recognizes and nurtures young people\u2019s talents. I had already started something similar at my school, but I knew that young people in my home community had talents that were not being recognized. I had a well-written proposal, and fortunately, the Executive Secretary liked the idea and welcomed it.',
      },

      {
        text: 'I started the initiative with the name “Cyanika Youth Estimation.” I organized a summit and invited many young people. At the very first event, more than 200 youth attended. It was a successful day, attended by local leaders, and they all appreciated it. I structured it well, forming an administration led by young volunteers who were reporting to me even while I was still in school.',
      },

      {
        text: 'The idea grew, and we began implementing different projects in education, health, culture, and art. We organized summits where young people showcased their talents and were rewarded. We received support from our main partner, Never Again Rwanda. In 2019, when I was in Senior Six, we organized a major event called “My Talent, My Property.” It was attended by former Minister of Local Government, Hon. Gatabazi Jean Marie Vianney, who was by then the Northern Province Governor, as well as other notable government officials. By that time, our initiative had evolved from a club into an NGO and changed its name to “Youth Estimation for Peace and Development.”',
      },

      {
        text: 'Today, I serve as the Executive Director of that NGO, a journey that began all the way back in Senior Five. I have now completed my university studies. I earned a diploma from RP Kigali College and later upgraded to a bachelor\u2019s degree in Electronics and Telecommunication from Gishari RP College. I currently manage and work with Youth Estimation for Peace and Development, and I am proud of how far we\u2019ve come and what we are planning to do soon.',
      },

      {
        text: 'To ASEF students: I challenge you not only to earn good grades, although that\u2019s important, but to understand that success goes beyond academics. Academic intelligence is one part of success, but I encourage you to become wise. Use your knowledge to solve real-world problems and engage in meaningful activities even while in school. I wish you a bright and successful future!',
      },
    ],
  },

  {
    id: 5,
    name: 'Mugwaneza Valentine',
    role: 'Secondary School Teacher',
    location: 'RWANDA',
    image: valentine,
    paragraphs: [
      {
        text: 'Valentine is an ASEF graduate from Rulindo District. She was supported by ASEF throughout her six years of secondary school. She is the third of eight children and was raised by her mother alone, in a very financially vulnerable family.',
      },
      {
        text: 'She completed her primary education at GS Murama, a school in her village from Rulindo District. In Primary national examination, she performed very well, scoring 13 aggregates under the 2013 ranking system. Despite her excellent grades, she never thought of joining a boarding school because her mother could not afford the school fees.',
      },
      {
        text: 'As a result, she enrolled in the nearby Nine-Year Basic Education school in her village, where she studied for over a week. One day, as she returned home from school, her mother told her that one of her teachers had come looking for her. The teacher said there was a program searching for bright but financially vulnerable students to support. She didn’t even know where the district offices were located, but her mother accompanied her there the next day.',
      },
      {
        text: (
          <>
            {' '}
            That's when she learned about ASEF. As part of the selection
            process, they were given a sheet of paper and asked to write an
            essay about what they would do if they became a leader.{' '}
            <i>
              “Though I was young at the time, I was sharp and able to speak
              up!”
            </i>{' '}
            Valentine said
          </>
        ),
      },

      {
        text: (
          <>
            One week later, she received a call to the neighbor's phone number,
            that she had used on the application form since her family didn’t
            own a phone. She was informed that she had been selected.{' '}
            <i>
              “Upon hearing that, I was very happy. I remember cheering up and
              dancing a lot. It was unbelievable.”
            </i>{' '}
            <i>
              “I went to collect my school supplies and the attestation letter
              confirming ASEF would pay for my education at École Secondaire de
              Nyamugali. They gave me a lot of supplies and materials. It was so
              much, but I managed to carry it all by myself,”
            </i>{' '}
            she recalled.
          </>
        ),
      },
      {
        text: 'Valentine emphasized that being selected by ASEF felt unreal, especially receiving all the materials, including a mattress, which they had never had at home. It was beyond what she had ever imagined.',
      },
      {
        text: 'Later, she continued her studies at Groupe Scolaire St. Aloys Rwamagana, where she pursued the PCB (Physics-Chemistry-Biology) combination. She then went on to study at the University of Rwanda, earning a bachelor\u2019s degree in Biology and Chemistry Education, which she is now applying in her profession.',
      },
      {
        text: (
          <>
            <i>
              “Before I even graduated from university, I received a job offer
              to teach at Rwanda Muslim Cultural School in Nyamirambo. Out of 50
              applicants, only three were selected, and I was one of them. It
              was wonderful to begin working even before graduating.”
            </i>{' '}
          </>
        ),
      },

      {
        text: 'Today, Valentine is a happy woman, married and continuing to grow in her education career. She has achieved several milestones, including being selected to serve on the team in Nyarugenge District responsible for preparing student examinations in 2024.',
      },

      {
        text: (
          <>
            Her message to ASEF students is clear:{' '}
            <i>
              “You've received a rare chance; many children don’t get a sponsor
              like ASEF. Don’t waste that opportunity. Listen to the advice ASEF
              gives you and do your best for yourself. In everything you do,
              never lose hope. Do it with hope, because I believe and I know
              that things will go well if you keep moving forward. There is
              nothing that can help you grow and develop like education. So,
              take it seriously.”
            </i>{' '}
          </>
        ),
      },
    ],
  },

  {
    id: 6,
    name: 'Niyigaba Jean Paul',
    role: 'Senior Auditor at BDO Rwanda',
    location: 'RWANDA',
    image: niyigaba,
    paragraphs: [
      {
        text: 'Jean Paul Niyigaba is a proud Rwandan, born and raised from Kisaro Sector in Rulindo District. He is passionate about lifelong learning, hard work, and making a difference through his profession. His educational journey began at GS Murama, where he completed both his primary and ordinary level studies. Later, he moved to GS APAPERC Murambi, choosing the Humanities option for his advanced level studies. During that time, he was fortunate to be supported by the African Student Education Fund (ASEF) a partnership that played a key role in shaping his future. Jean Paul graduated in 2017 with an outstanding score of 73 out of 73, a reflection of his strong commitment to education and personal growth.',
      },
      {
        text: 'He went on to pursue a bachelor’s degree in finance specialization at the University of Rwanda, where he graduated with a Second-Class Upper Division, scoring an impressive 81%. Eager to deepen his professional expertise, Jean Paul hold in the Certified Public Accountant (CPA) since 2021, a program offered by the Institute of Certified Public Accountants of Rwanda (ICPAR). He is currently pursuing a Master of Business Administration (MBA) in Finance at the University of Rwanda.',
      },
      {
        text: 'Professionally, Jean Paul began his career in 2022 as an auditor, gaining valuable experience with international audit and accounting firms of BDO and PwC. His work has spanned both public and private sector audit engagements, allowing him to grow and refine his skills in terms of Compliance check, financial analysis, financial reporting, accounting standards as well as leadership and management. Today, he serves as a Senior Auditor at BDO Rwanda, where he continues to contribute to excellence in financial accountability and audit quality.',
      },

      {
        text: 'A Message to Current ASEF Students.',
      },
      {
        text: (
          <>
            <i>
              “To every student out there still walking your journey with the
              assistance of ASEF, I see you, and I was once you. I know the
              challenges, the late nights, the doubts, and the dreams. I want
              you to know that this support you are receiving is a seed one that
              can grow into something incredible if you stay focused,
              disciplined, and hungry to learn. I am where I am today because I
              embraced every chance I was given, even when things seemed tough.
              So, keep pushing forward, believe in yourself even when it’s hard,
              and never stop dreaming. One day, just like me, you'll look back
              and see how far you’ve come, and you'll be proud you never gave
              up.”
            </i>{' '}
          </>
        ),
      },
    ],
  },

  {
    id: 7,
    name: 'Niyomugabo Celestin',
    role: 'Founder and CEO of VONSUNG',
    location: 'RWANDA',
    image: niyomugabo,
    paragraphs: [
      {
        text: 'Celestin Niyomugabo is an ASEF graduate from Gakenke District. He is a passionate, hardworking, and goal-oriented individual who has accomplished a lot in his career, even starting from his student days. He comes from Gakenke District and completed his primary education at École Primaire Protestant de Gakenke, located near his home. He attended his Ordinary Level studies at École Secondaire de Nyarutovu (ECOSENYA). By that time his mother was struggling alone to support the family. Despite these challenges, Celestin excelled in the national examinations, scoring 13 aggregates under the 2012 ranking system.',
      },

      {
        text: 'After completing Ordinary Level, it became very difficult for his family to finance his Advanced Level education, not only because of the financial situation but also because there were more two children in the family attending school at the same time. “I remember during Ordinary Level, my brother—who was in the same class as me, used to skip school, especially on Tuesdays and Fridays, to work at the market and earn a little money to support our education,” Celestin recalled.',
      },

      {
        text: 'With the hope of attending boarding school fading day by day, and after many failed attempts to find a scholarship through different programs, Celestin’s sector education officer added his name to a list of students who might be selected by ASEF. A week later, he got the call.',
      },
      {
        text: (
          <>
            <i>
              “I went to the district and met with ASEF. I thought they would
              only cover half the tuition, as many organizations do, but I was
              shocked in a good way. ASEF payed the full school fees and gave me
              all the school supplies and hygienic materials I needed. I
              remember calling my mom in excitement, saying, ‘Yesss… it
              happened!’”
            </i>{' '}
            he said.
          </>
        ),
      },
      {
        text: 'Upon arriving at school, Celestin felt proud and confident. With the support ASEF had provided, he said that no one could tell the difference between him and a student from a wealthy family. He maintained excellent performance and graduated from high school with outstanding results.',
      },
      {
        text: 'Even while in school, Celestin stood out as an innovative and open-minded student. He explored various business ideas and developed 8 business plans when he was in Senior 5. Among his first ventures was a cooperative bakery he started with eight O’level classmates. He was used to run it during school holidays, although it was later dissolved due to challenges in consistent management.',
      },
      {
        text: (
          <>
            <i>
              “I had not just eight business plans when I was in secondary, but
              that’s also when the big idea for the business I run today came to
              life: VONSUNG, which means ‘Sign of Success.’ I knew that one day,
              I’d start a company with that name, and that it would be my
              personal sign of success,”
            </i>{' '}
            he said.
          </>
        ),
      },
      {
        text: 'Celestin went on to join the University of Rwanda to pursue a Bachelor of Science in Applied Statistics. In his first year, he made a personal commitment: to learn one new skill every year. In Year 1, he learned front-end development online from Alison [www.alison.com]; in Year 2, creative design; Year 3 was videography; and in Year 4, back-end programming all going together with Statstics modules he was taking in University.',
      },
      {
        text: (
          <>
            <i>
              “Throughout university, I kept learning skills to complement my
              applied statistics coursework. Many students would ask me
              questions about software modules, so I decided to form a group of
              30 students to study together. That group became so business
              oriented that we renamed it the ‘Programmers Team,’ and we started
              learning skills beyond statistics,”
            </i>{' '}
            he said.
          </>
        ),
      },
      {
        text: 'From that group, made up of students from different academic years, came the idea of launching a business. Their first venture was called Universe Investment, which operated for three years before it dissolved when members graduated and went their separate ways. Celestin was still in his second year when he got idea of making that group.',
      },
      {
        text: 'Not one to give up, he started thinking about businesses that didn’t require physical meetings. Inspired by the challenges of the COVID-19 pandemic, he created a job portal website that eventually earned him a 1 million Rwandan Franc prize from the 2020 YouthConnekt competition.',
      },

      {
        text: (
          <>
            <i>
              “YouthConnekt 2020 was the real starting point of my current
              business. After winning the prize, they said they would visit me
              at my workplace, but I didn’t have one at the time. That pushed me
              to rent an office, and that’s what opened the door to VONSUNG,”
            </i>{' '}
            he explained.
          </>
        ),
      },

      {
        text: 'Celestin then fully launched VONSUNG, a company he had officially registered back in July 2019. The business began gaining traction, and he formed a team. Today, he is the Founder and CEO of VONSUNG, which specializes in computer programming, data processing, and integrated systems design. The very skills he learned from the “Programmers Team” and through self-study became departments within the company. “Don’t underestimate the power of learning. Even if you’re not earning from a skill now, it\u2019s developing your mind,” he said.',
      },

      {
        text: 'Today, through VONSUNG, Celestin has purchased Little Angels Nursery School located in his home district, launched V-Farm with over 1,500 chickens, and works as a Principal Professional in Charge of Revenue Modelling at the Rwanda Revenue Authority. He is also pursuing a Master’s degree in Big Data at the Adventist University of Central Africa and is committed to giving back to his community as he already started.',
        linkObj: {
          new_line: false,
          link: '',
        },
      },
      {
        text: 'His advice to current ASEF students is clear:',
      },
      {
        text: (
          <>
            <i>
              “Hard work always pays off. Nothing comes overnight. You need to
              work for it. Use the critical thinking you develop in school to
              solve real-life problems. And when you succeed, remember to give
              back to your community.”
            </i>{' '}
          </>
        ),
        text: '',
      },

      {
        text: 'Personal website:',
        linkObj: {
          new_line: false,
          link: 'https://celestinniyomugabo.com',
        },
      },

      {
        text: 'VONSUNG:',
        linkObj: {
          new_line: false,
          link: 'https://vonsung.co.rw',
        },
      },

      {
        text: 'Little Angels Nursery Nursery School:',
        linkObj: {
          new_line: false,
          link: 'https://littleangels.ac',
        },
      },
    ],
  },
  {
    id: 8,
    name: 'Ntakirutimana Elie',
    role: 'Student at cornell  University',
    location: 'USA',
    image: elie,
    paragraphs: [
      {
        text: 'I am known for my unwavering spirit, empathy, and resilience. In the face of adversity, I love demonstrating unshakable determination and a relentless pursuit of self-improvement. My defining trait is my deep desire to make a difference,with dreams rooted in altruism and a commitment to transforming the lives of the vulnerable.',
      },
      {
        text: "I have been supported by ASEF in my advanced level from 2019 to 2022. I began my academic pursuits at GS Kivumu, a lesser-known public school, during my ordinary-level studies. However, a turning point came when I achieved exceptional results at the district level in Kamonyi, leading me to apply to ASEF, which subsequently became the catalyst for my dreams. ASEF's support enabled me to enroll at the prestigious GSO Butare. There, I seized every opportunity, excelling in competitions like the Wavumbuzi Entrepreneurship Challenge, where I secured first place in Water Quest at a national level. Furthermore, I proudly ranked fifth in General Education countrywide during the Advanced Level National Examinations, a testament to my dedication and growth.",
      },
      {
        text: "I'm currently pursuing my Bachelor's Degree in Agricultural Sciences at Cornell University, an esteemed Ivy League institution in New York, US. After completing Senior 5, I had the opportunity to join Isomo Academy, an English immersion program affiliated with Bridge2Rwanda. My college counselors at Bridge2Rwanda are the ones who told me to apply to Cornell. They played a pivotal role in my college application process, assisting me in selecting schools, crafting essays, and equipping me with essential information about college life. Their support has been instrumental in my educational journey.",
      },
      {
        text: "Seeking admission to a prestigious university requires more than good grades; it necessitates a foundation of values and unwavering commitment. The advice is straight forward: First, know that you went to study not to school, ''view your education as an opportunity, work diligently, dream ambitiously, stay open-minded, and seek opportunities. Understand that challenges are inevitable on the path to such universities, but after every setback, there's a chance for success. Cultivate curiosity, as it fuels the quest for knowledge, and embrace failures as valuable lessons. In essence, combine academic excellence with resilience, ambition, curiosity, and a growth mindset to reach your goals. Never give up!",
      },
    ],
  },
  {
    id: 9,
    name: 'Nkurunziza Ghad',
    role: 'Student at Wesleyan University',
    location: 'USA',
    image: ghad,
    paragraphs: [
      {
        text: 'Growing up as the firstborn, I grew up in a low-income family of two parents and four siblings in the rural area part of Rwanda, Burera-Butaro. Looking at myself, risk-taking, persistence and a growth mindset define the truest essence of my personality',
      },
      {
        text: "2016 is when I joined ES Runaba in O' level. Confused like any other senior 1 student, I had no clear path of my future ambitions.When I went to classes, my English was questionable, my critical thinking skills were still sleeping, and my goal-setting skills were still young. However, I remember the day I had a conversation with my physics teacher, that's when I realized that the future holds something for me and what I needed only was sacrificing my time and spending it on books and classes. Going to an advanced level, the vision was bigger.With the primary intention of seeing the plane with my eyes, I decided to choose ES.KANOMBE/EFOTEC over any other other school countrywide. Honestly speaking, no specific thing I knew about EFOTEC except that it was near the Kigali International Airport.",
      },

      {
        text: "In the midst of Covid-19, God revealed the bride to my destiny; Isomo Academy. Without hesitation, I applied and fortunately was accepted to join the cohort of 120 brilliant students from all over the country. Being in ISOMO Academy opened my eyes to the world outside the books and classrooms, and taught me the importance of looking around and giving a hand to the needy. From Isomo, that's where I learned that nothing is impossible; just it requires a trial denies mediocrity",
      },
      {
        text: "Beyond community engagement and class reading, applying for college was the next. This was the most challenging and toughest journey of my education career. I applied to 20 colleges in the US, but the results were heartbreaking. After 19 depressing moments of rejection, I was accepted into Wesleyan University and this proves that multiple failures are not the end of someone's life. Today, I'm in college, but whenever I look back to my past, the obstacles on my way to this milestone were uncountable, but persistence determination, and God's blessing only guaranteed me victory",
      },
      {
        text: "Beautiful ASEF's daughters and sons, remember that it's not too late to pursue your dreams. Build a strong heart to stand the rejections and failures, but remember that only time heals. Get rid of mediocrity, and always read books; that's how you fight self-supported ignorance. The world has many opportunities, but remember opportunities will never chase you; go chase them. Find something you're better at, free yourself, and hunt for excellence in it. Your teachers, classmates, Deans of studies, parents, neighbors, and friends, everyone can be a bridge to your success; respect and learn from them. But remember, people are different; don't surround yourself with people who don't value your dreams they can make you lose track of the final point. More importantly, success is always worked for, so stay motivated, work a bit harder, and maintain excellent discipline.",
      },
    ],
  },
  {
    id: 10,
    name: 'Nizeyimana Emmanuel',
    role: 'Student at Gahini GS',
    location: 'RWANDA',
    image: emmanuel,
    paragraphs: [
      {
        text: "Njyewe natangiye kwiga ntinze bitewe n'imyumvire ndetse n'ubushobozi bw'umuryango nkomokamo. Njyeze mu mwaka wa gatandatu w'amashuri abanza nafataga umwanya nkajya ku muhanda mugihe abanyeshuri biga mu mashuri yisumbuye babaga bahetse ibikapu bagiye ku bigo biga babamo.",
      },
      {
        text: "Numvaga mfite inzozi zo kuzajya kwiga mbamo nanjye ariko nkabona ntaho bizaturuka kuko nubwo narumuhanga ntago ubushobozi bwari kuboneka.Nsoje amashuri abanza rero nagize amanota meza ku bw'amahirwe ASEF intoranya mubana bagomba gufashwa, byabaye ikiraro cyo gutuma inzozi zanjye ziba impamo.Ubu ndi mu mwaka wa gatatu wamashuri yisumbuye ariko mpora nkora cyane kugira ngo mbashe kuzagera kuri byinshi muhazaza hanjye ndetse nzahindure n'ubuzima bw'umuryango wanjye.",
      },
      {
        text: 'Ndashimira cyane ASEF ndetse  nshishikariza abanyeshuri bagenzi banjye kudapfusha ubusa amahirwe twagize!',
      },
      {
        text: 'Murakoze!',
      },
    ],
  },
];

const Story = ({ chosenStory, setChosenStory, setNavigateToSection }) => {
  return (
    <div className="w-full h-fit">
      <div className="w-full flex flex-col px-6 md:px-12 py-6 lg:px-32 lg:py-12">
        <div id="main_story" className="w-full mb-6">
          {stories.map((story) => {
            if (story.id === chosenStory) {
              return (
                <div key={story.id} className="w-full flex flex-col gap-6">
                  <div className="w-full flex flex-col lg:flex-row items-start gap-6">
                    <div className="w-full lg:w-1/2 rounded-2xl overflow-hidden">
                      <img
                        src={story.image}
                        alt={story.name}
                        className="w-full object-contain max-h-[400px]"
                      />
                    </div>
                    <div className="w-full lg:w-1/2 flex flex-col gap-4 mt-12">
                      <h1 className="font-quicksand font-semibold text-2xl">
                        {story.name}
                      </h1>
                      <p className="font-rubik text-sm text-fontGrey">
                        {story.role}
                      </p>
                      {story.date && (
                        <p className="font-rubik text-sm text-fontGrey">
                          Posted on {story.date}
                        </p>
                      )}

                      <p className="font-rubik text-fontGrey text-lg mt-1">
                        {story.paragraphs[0].text}
                      </p>
                    </div>
                  </div>

                  {/* Render all paragraphs except the first one */}
                  {story.paragraphs.slice(1).map((paragraph, index) => (
                    <div key={index}>
                      {paragraph.header ? (
                        <p className="font-bold text-fontBlack">
                          {paragraph.header}
                        </p>
                      ) : paragraph.image ? (
                        <div className="flex flex-col items-center">
                          <div
                            className={`bg-cover w-fit overflow-hidden rounded-2xl ${
                              paragraph.dimensions || ''
                            }`}
                          >
                            <img
                              src={paragraph.image}
                              alt={paragraph.image_description || ''}
                              className="w-full h-full object-contain max-w-[800px] max-h-[500px]"
                            />
                          </div>
                          {paragraph.image_description && (
                            <p className="text-sm text-fontGrey italic">
                              {paragraph.image_description}
                            </p>
                          )}
                        </div>
                      ) : paragraph.youtube ? (
                        <div className="max-w-full rounded-lg lg:rounded-3xl overflow-auto mt-6 mx-auto">
                          <iframe
                            width="800"
                            height="600"
                            src={paragraph?.youtube}
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                            className="w-full aspect-video my-auto"
                          ></iframe>
                        </div>
                      ) : (
                        <p className="font-rubik text-fontGrey text-lg">
                          {paragraph.text}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default Story;
